module.exports = __webpack_public_path__ + "static/img/job1.15f008a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/job1.png
// module id = cHiC
// module chunks = 0